export const BASE_URL = "https://192.168.1.203:8000";